import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {

  transform(dateString: string): string {
    if (!dateString) return '';

    // const [day, month, year] = dateString.split('/');
    const [year, month, day] = dateString.split('-'); // Cambiado para formato YYYY-MM-DD
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

    const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const dayName = dayNames[date.getDay()];

    return `${dayName} ${day.padStart(2, '0')}`;
  }
}
